import * as React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import noDataPic from '../Assets/NoDataLarge.svg';

export const NoData: React.FC = (): React.ReactElement => {
  return (
    <>
      <Column
        width='100%'
        heights='fill'
        alignmentHorizontal='center'
        minHeight='30vh'
      >
        <Row>
          <img src={noDataPic} alt='No data' />
        </Row>
        <Row>
          <Text type='h200'>
            <FormattedMessage
              id='cs_perfportal_noDataToReport'
              defaultMessage='No data to report'
            />
          </Text>
        </Row>
      </Column>
    </>
  );
};
